import React, { useEffect } from 'react'
import OwlCarousel from 'react-owl-carousel'
import '../assets/owl carousel/owl.carousel.min.css'
import '../assets/owl carousel/owl.theme.default.min.css'
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/about.css'

export default function About() {

  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  return (
    <div className='about_page page_body'>
      <PageTransition />
      <div className='container'>
        <div className="page_title"><span>A</span>BOUT US</div>
        <div className="wrapper">
          <div className="banner">
            <OwlCarousel
            className='owl-theme' 
            items={1} 
            autoPlay={true} 
            autoplayHoverPause={true} 
            autoplaySpeed={1000} 
            loop={true}>
              <div className="item">
                <img src={require('../assets/images/course banners/banner-01.png')} alt="About Banner" />
              </div>
              <div className="item">
                <img src={require('../assets/images/course banners/banner-01.png')} alt="About Banner" />
              </div>
              <div className="item">
                <img src={require('../assets/images/course banners/banner-01.png')} alt="About Banner" />
              </div>
            </OwlCarousel>
          </div>
          
          <div className="about_text">CodoHov is an IT institute by <a href=''>Hovered Group</a>. It was founded to serve people easy and better learning. We are providing quality courses based on Software Development, Design, Programming and Marketing etc. All of our courses are directed by professinal mentors across the country. <br /> A large amount of people are still unemployed in this country. But skill development can solve this problem. The unemployed people can learn and apply those skills to earn money by freelancing. Our aim is to solve this massive problem of our country by serving people the skill development courses at low price. <br /><br /> To serve the nation a bunch of manpower is our aim!</div>
        </div>
      </div>
    </div>
  )
}
